import { render, staticRenderFns } from "./PricingTables.vue?vue&type=template&id=85522c30"
import script from "./PricingTables.vue?vue&type=script&lang=js"
export * from "./PricingTables.vue?vue&type=script&lang=js"
import style0 from "./PricingTables.vue?vue&type=style&index=0&id=85522c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports